import l10n from '../i18n/I18N'

import { useCryptoPaymentModal } from '../CryptoPaymentModal'
import { useCryptoPackageModal } from './CryptoPackageModalProvider'

import classes from './styles/cryptoPackageModalHeader.module.scss'

export const CryptoPackageModalHeader = () => {
  const { handleCloseCryptoPackageModal } = useCryptoPackageModal()
  const { handleOpenCryptoPaymentDepositModal } = useCryptoPaymentModal()

  return (
    <>
      <div className={classes.cryptoPackageModalHeader_title}>{l10n.t['cryptopackage.header']}</div>
      <div className={classes.cryptoPackageModalHeader_bundles}>{l10n.t['cryptopackage.bundles.label']}</div>
      <div className={classes.cryptoPackageModalHeader_bundlesDescription}>
        {l10n.t['cryptopackage.bundles.description']}
      </div>
      <div className={classes.cryptoPackageModalHeader_alternativeSection}>
        <div className={classes.cryptoPackageModalHeader_alternativeDescription}>
          {l10n.t['cryptopackage.bundles.alterantive']}
        </div>
        <button
          onClick={() => {
            handleCloseCryptoPackageModal()
            handleOpenCryptoPaymentDepositModal()
          }}
          className={classes.cryptoPackageModalHeader_alternativeButton}
        >
          {l10n.t['cryptopackage.bundles.alterantiveButton']}
        </button>
      </div>
    </>
  )
}
